import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.css';
import 'katex/dist/katex.min.css';
import './index.css';
import './assets/styles/global.scss';
import './assets/styles/override.boostrap.scss';
import './assets/styles/override.suneditor.scss';
import './assets/nucleo-icons/scss/icons.scss';
import App from './App';
import { setupStore } from './store/store';

//set-up store
const store = setupStore();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <App />
      </Provider>
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();
